import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ConfirmDirective} from "../../../../../directives/confirm/confirm.directive";
import {IsGrantedDirective} from "../../../../../directives/is-granted/is-granted.directive";
import {PaginatorComponent} from "../../../../layout/paginator/paginator.component";
import {TableSorterHeaderDirective} from "../../../../../directives/table-sorter/table-sorter-header.directive";
import {RouterLink} from '@angular/router';
import {Paginator} from '../../../../../tools/pagination/paginator';
import {TableSorter} from '../../../../../tools/table-sorter/table-sorter';
import {LangService} from '../../../../../services/language/lang.service';
import {DialogService} from '../../../../../services/dialog/dialog.service';
import {LoaderService} from '../../../../../services/loader/loader.service';
import {SnackbarService} from '../../../../../services/snackbar/snackbar.service';
import {AvailableDomain} from '../../../../../models/cms/available-domain';
import {AvailableDomainService} from '../../../../../services/cms/available-domain.service';
import {TableSorterDirective} from '../../../../../directives/table-sorter/table-sorter.directive';
import {MetaTitle} from '../../../../../decorator/meta-title';
import {IsGranted} from '../../../../../decorator/is-granted';
import {NgOptimizedImage} from '@angular/common';

@Component({
  selector: 'app-available-domain-list',
  imports: [
    ConfirmDirective,
    IsGrantedDirective,
    PaginatorComponent,
    TableSorterHeaderDirective,
    RouterLink,
    TableSorterDirective,
    NgOptimizedImage
  ],
  templateUrl: './available-domain-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './available-domain-list.component.scss'
})
@IsGranted(['STATIC_PAGE_VIEW'])
@MetaTitle('Domain Configuration List')
export class AvailableDomainListComponent implements OnInit {
  availableDomains: AvailableDomain[] = [];

  paginator: Paginator = new Paginator();
  tableSorter: TableSorter = new TableSorter('id', 'asc');

  constructor(
    protected langService: LangService,
    private dialog: DialogService,
    private loader: LoaderService,
    private snackbar: SnackbarService,
    private availableDomainService: AvailableDomainService,
  ) {
  }

  ngOnInit(): void {
    this.fetchAll();
  }

  fetchAll(): void {
    this.loader.startLoading();
    this.availableDomainService.findAll({}, this.paginator, this.tableSorter).subscribe((availableDomains: AvailableDomain[]) => {
      this.availableDomains = availableDomains;
      this.loader.stopLoading();
    });
  }

  delete(availableDomain: AvailableDomain): void {
    if (availableDomain.id) {
      this.loader.startLoading();
      this.availableDomainService.delete(availableDomain.id).subscribe(() => {
        this.loader.stopLoading();
        this.snackbar.success('The domain has been deleted');
        this.fetchAll();
      });
    }
  }
}
